module.exports = __webpack_public_path__ + "prod/1.42.2/img/xtrh_three.46ff6332.png";